import { i18n } from "i18n";
import { KNOWN_ERROR_STATUS_CODES } from "../../../CommonErrorPopup/CommonErrorPopup";

const getErrorByCode = (
  defaultError: { title: string; description: string },
  code?: number
) => {
  if (KNOWN_ERROR_STATUS_CODES.includes(code || 0)) {
    return {
      title: i18n.t(`common:errorPopup.httpStatus.${code}.title`),
      description: i18n.t(`common:errorPopup.httpStatus.${code}.body`),
    };
  }

  return defaultError;
};

export const getErrorPopupTexts = (code?: number) => {
  const closeButtonText = i18n.t("common:button.label.close");

  return {
    systemError: {
      ...getErrorByCode(
        {
          title: i18n.t("common:errorPopup.httpStatus.system.title"),
          description: i18n.t("common:errorPopup.httpStatus.system.body"),
        },
        code
      ),
      closeButtonText,
    },
    accountError: {
      title: i18n.t("common:errorPopup.httpStatus.401.title"),
      description: i18n.t("common:errorPopup.httpStatus.401.body"),
      closeButtonText,
    },
    accountAccessError: {
      title: i18n.t("common:errorPopup.httpStatus.403.title"),
      description: i18n.t("common:errorPopup.httpStatus.403.body"),
      closeButtonText,
    },
    networkError: {
      ...getErrorByCode(
        {
          title: i18n.t("common:errorPopup.httpStatus.network.title"),
          description: i18n.t("common:errorPopup.httpStatus.network.body"),
        },
        code
      ),
      closeButtonText,
    },
  };
};
